export interface ThresholdColorPalette {
  defaultColor: string;
  palette: string[];
  labelBackgroundColor?: string;
  labelColor?: string;
}

export const THRESHOLD_SERIES_NAME_PREFIX = '___THRESHOLD___';
